import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('Invitation', InvitationData);

    function InvitationData() {
        Invitation.prototype = {
            build: build,
            buildEmpty: buildEmpty
        };

        function Invitation(invitationData) {
            if (!invitationData) {
                this.buildEmpty();
            } else {
                this.build(invitationData);
            }
        }

        return Invitation;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.sentDate = null;
            this.lastRemindDate = null;
            this.remindCount = null;
            this.ackDate = null;
            this.contactFirstName = null;
            this.contactLastName = null;
            this.contactEmail = null;
            this.contactPhone = null;
        }

        function build(invitationData) {
            this.id = invitationData.id
            this.sentDate = invitationData.sentDate || null ;
            this.lastRemindDate = invitationData.lastRemindDate || null;
            this.remindCount = invitationData.remindcount || 0;
            this.ackDate = invitationData.ackDate || null ;
            this.contactFirstName = invitationData.contactFirstName || null;
            this.contactLastName = invitationData.contactLastName || null;
            this.contactEmail = invitationData.contactEmail || null;
            this.contactPhone = invitationData.contactPhone || null;
        }
    }
})();
